import Contract from "./contract.page";

export default Contract;
